export const colors = {
  primary: "#191D29",
  secondary: "#F78419",

  tertiary: "#191D29",

  textColor: "#192031",

  gradient:
    "background: linear-gradient(0deg, #F78419, #F78419),linear-gradient(90deg, #F07A18 0%, #C93221 100%)",
  gradientBtn: "linear-gradient(90deg, #F07A18 0%, #C93221 100%)",
};

export const theme = {
  subHeading: {
    color: "#fff",
    fontFamily: "Mulish-SemiBold",
    fontSize: "18px",
  },

  lightBorder: `1px solid rgba(247,132,25,0.5)`,
};
